<template>
  <b-row v-if="campaign._id">
    <b-col>
      <b-alert show v-if="emailSent">Stage has been sent to all filtered recipients!</b-alert>
      <div v-if="stages.length > 0">
        <div
          v-for="(stage, stageIndex) in stages"
          :key="stageIndex"
          class="my-3"
        >
          <b-alert
            show
            variant="info"
            class="my-3"
            v-if="stage.send_after_stage && stage.days_after_stage"
          >Wait {{ stage.days_after_stage }} days until next stage</b-alert>

          <b-card
            :header="stage.name"
            header-tag="h4"
            header-bg-variant="white"
            footer-bg-variant="white"
          >
            <div>{{ stage.email_subject }}</div>
            <div>{{ stage.sender_name }} ({{ stage.sender_email }})</div>

            <div slot="footer" class="d-flex">
              <b-button :to="{ name: 'campaigns-edit-stages-edit', params: { id: campaign._id, stageid: stage._id } }" variant="outline-secondary" size="sm">Edit</b-button>

              <b-button
                variant="outline-secondary"
                size="sm"
                class="ml-2"
                :disabled="stageIndex === 0"
                @click="moveStageUp(stage._id)"
              >Move Up</b-button>

              <b-button
                variant="outline-secondary"
                size="sm"
                class="ml-1"
                :disabled="stageIndex === stages.length - 1"
                @click="moveStageDown(stage._id)"
              >Move Down</b-button>

              <b-button variant="outline-secondary" size="sm" @click="sendStage(stage._id)" class="ml-2">Send Email</b-button>
              <b-button variant="outline-danger" size="sm" @click="removeStage(stage._id)" class="ml-auto">Delete</b-button>
            </div>
          </b-card>
        </div>
      </div>

      <b-container class="pt-3">
        <b-row>
          <b-col>
            <b-alert show variant="info" v-if="stages.length === 0">
              There are no stages in this campaign yet.
            </b-alert>
          </b-col>
        </b-row>
      </b-container>

      <b-button v-if="stages" :to="{ name: 'campaigns-edit-stages-create', params: { id: campaign._id } }" variant="outline-primary">Create Stage</b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import store from '../store'

export default {
  async beforeRouteEnter(to, from, next) {
    await Promise.all([
      store.dispatch('campaigns/fetchOne', to.params.id),
      store.dispatch('stages/fetchAll', to.params.id)
    ])

    next()
  },

  data() {
    return {
      emailSent: false
    }
  },

  computed: {
    ...mapState('campaigns', [
      'campaign'
    ]),
    ...mapState('stages', [
      'stages'
    ])
  },

  methods: {
    ...mapActions('stages', [
      'fetchAll',
      'deleteStage',
      'sendStageByEmail',
      'moveStageUp',
      'moveStageDown'
    ]),

    removeStage(stageId) {
      if (confirm(`Are you sure you want to delete this stage? (ID: ${stageId})`)) {
        this.deleteStage(stageId)
      }
    },

    async sendStage(stageId) {
      this.emailSent = false
      if (confirm(`Are you sure you want to Send this stage? This will mannualy trigger a send of this email to all recipients in the currently selected filter.`)) {
        await this.sendStageByEmail({ stageId })
        this.emailSent = true
      }
    }
  }
}
</script>
